import { render, staticRenderFns } from "./UserSelf.vue?vue&type=template&id=19a6a962&"
import script from "./UserSelf.vue?vue&type=script&lang=js&"
export * from "./UserSelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports